// Centralized bypass for captain/premium feature gates on self-hosted installations.
//
// Any feature flag whose name starts with one of these prefixes is force-enabled,
// so new captain_* flags added in future Chatwoot releases are covered automatically.
const BYPASSED_FEATURE_PREFIXES = ['captain'];

// Exact feature-flag names to force-enable that do not share the prefixes above.
// e.g. Captain "Custom Tools" ships under the flag `custom_tools` (added in v4.16.0).
const BYPASSED_FEATURE_NAMES = ['custom_tools'];

export function isBypassedFeature(featureName) {
  if (!featureName) return false;
  if (BYPASSED_FEATURE_NAMES.includes(featureName)) return true;
  return BYPASSED_FEATURE_PREFIXES.some(p => featureName.startsWith(p));
}
